export const PageSize = 30;
export const ContactMasterAlias = 'contact-master';
export const BlogPageSize = 10;
export const fsuBrands = ['Proximity Mills', 'Doma', 'Newton', 'Paradiso'];
export const localBusinessTokens = [
  '@@companyname@@',
  '@@logosrc@@',
  '@@address@@',
  '@@structured_address_city@@',
  '@@structured_address_zip@@',
  '@@structured_address_state@@',
  '@@structured_address_street@@',
  '@@structured_address_country@@',
  '@@structured_address_latitude@@',
  '@@structured_address_longitude@@',
  '@@opening_hours@@',
];

export const dateTokens = ['@@datesMacro@@', '@@minDate@@'];

export const formTokens = [
  '@@appointmentTimes@@',
  '@@productMacro@@',
  '@@companyname@@',
  '@@address@@',
  '@@email@@',
  '@@logosrc@@',
  '@@marketplacecoupon@@',
  '@@phone@@',
  '@@structured_address_city@@',
  '@@structured_address_state@@',
  '@@structured_address_zip@@',
  '@@structured_address_street@@',
  '@@structured_address_country@@',
  '@@allLocations@@',
  ...dateTokens,
];

export const HeaderGaStubScript = 'window.ga ??= () => {};';

export const defaultSiteMapPriority = {
  ContentPage: 0.7,
  Blog: 0.2,
  Articles: 0.5,
  ContentPageNavigation: 0.9,
};

export const floorforceImagePath = 'https://images.floorforce.com/Textures/';

export const ActonFormsWithFfCompanyIds = [
  'accessibility-form',
  'karastan-soft-surface-2021-campaign-form',
  'fall-national-karastan-month-21-campaign-form',
  'mhk-summer-national-sale-2023',
  'buyers-guide-carpet-form-omnify',
  'buyers-guide-hardwood-form-omnify',
  'buyers-guide-laminate-form-omnify',
  'buyers-guide-vinyl-form-omnify',
  'buyers-guide-tile-form-omnify',
];

export const BROADLUME_TERMS_AND_CONDITIONS =
  'https://www.broadlume.com/acceptable-use-policy';

export const Collation = {
  locale: 'en',
  strength: 2,
};
